<script>
export default {
  data () {
    return {
      secondaryFilters: [
        'foodTypes',
        'kitValidated',
        'ongoingValidation',
        'controlsRequired',
        'detectionLimits',
        'testSensitivity',
        'testSpecifityNZ',
        'confirmationPositiveResult',
        'confirmationDescription',
        'staffTimeInvolvement',
        'establishmentCost',
        'establishmentCostDescription',
        'equipmentNeeded',
        'labRequirements',
        'labRequirementsDescription',
        'disposalRequirements',
        'otherInformation'
      ]
    }
  },
  methods: {
    checkProperty (index) {
      return this.secondaryFilters.some(element => index === element)
    },
    formatIndex (index) {
      return index
        .replace(/[0-9]{2,}/g, match => ` ${match} `)
        .replace(/[^A-Z0-9][A-Z]/g, match => `${match[0]} ${match[1]}`)
        .replace(/[A-Z][A-Z][^A-Z0-9]/g, match => `${match[0]} ${match[1]}${match[2]}`)
        .replace(/[ ]{2,}/g, match => ' ')
        .replace(/\s./g, match => match.toUpperCase())
        .replace(/^./, match => match.toUpperCase())
        .trim()
    },
    formatValue (value) {
      if (value !== undefined && !Array.isArray(value)) {
        if (value === true) {
          return 'Yes'
        } else if (value === false) {
          return 'No'
        } else {
          return value
        }
      } else if (Array.isArray(value)) {
        return value.map(function (v) {
          return v.name
        }).join(',')
      } else {
        return '-'
      }
    }
  }
}
</script>
